const languageOptions = [
  { value: 'en', label: 'English (EN)' },
  { value: 'fr', label: 'French (FR)' },
  { value: 'ar', label: 'Arabic (AR)' },
  { value: 'pt', label: 'Portuguese (PT)' },
];

export default languageOptions;